import { memo } from 'react';
import isEqual from 'react-fast-compare';

import { SPREAD_METHOD_PAD } from './constants';
import GradientStop from './GradientStop';
import { RadialGradientFill } from './types';
import { normalizeGradientStops } from './utils';

type Props = RadialGradientFill['props'] & {
  id: string;
  from?: string;
  to?: string;
};

const RadialGradient = (props: Props) => {
  const {
    id,
    cx = 0.5,
    cy = 0.5,
    fr = 0,
    from = '',
    fx = 0.5,
    fy = 0.5,
    r = 0.5,
    spreadMethod = SPREAD_METHOD_PAD,
    stops,
    to = '',
  } = props;
  const gradientStops = normalizeGradientStops(from, to, stops);

  return (
    <radialGradient
      id={id}
      cx={cx}
      cy={cy}
      fr={fr}
      fx={fx}
      fy={fy}
      r={r}
      spreadMethod={spreadMethod}
    >
      {gradientStops.map((stopProps, key) => (
        <GradientStop key={stopProps.offset != null ? stopProps.offset : key} {...stopProps} />
      ))}
    </radialGradient>
  );
};

export default memo(RadialGradient, (props, nextProps) => isEqual(props, nextProps));
